import { FC } from 'react';
import SuperTreeSelect from '../SuperTreeSelect';
import SearchFormItem from './subpage/searchFormItem';
import SearchFormDisabled from './subpage/disabled';
import { getSelectPlaceholder } from '../utils/ruleUtils';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';
import { SuperTreeSelectProps } from '../SuperTreeSelect/treeSelect';
import { TABLE_COLUMN_EMPTY } from '../constants/constant';

export interface SearchFormTreeSelectProps extends BaseSearchFormItemProps {
  /** treeSelect Props */
  treeSelectProps?: SuperTreeSelectProps;
}
/** 下拉树 */
export const SearchFormTreeSelect: FC<SearchFormTreeSelectProps> = props => {
  const {
    treeSelectProps,
    isDetail,
    disabledRender,
    form,
    isTable,
    testId,
    label,
    rules,
    ...resProps
  } = props;
  return (
    <SearchFormItem {...resProps} label={label} rules={rules}>
      {isDetail || (treeSelectProps && treeSelectProps.disabled) ? (
        <SearchFormDisabled
          render={disabledRender || TABLE_COLUMN_EMPTY}
          form={form}
          isTable={isTable}
        />
      ) : (
        <SuperTreeSelect
          style={{ width: '100%' }}
          {...treeSelectProps}
          placeholder={getSelectPlaceholder(label, treeSelectProps, rules)}
          test-id={`${testId}-${resProps.name}`}
        />
      )}
    </SearchFormItem>
  );
};

SearchFormTreeSelect.displayName = SearchFormItemEnum.SearchFormTreeSelect;

export default SearchFormTreeSelect;
